import { AbstractApiRequest } from '@/communication/base/AbstractApiRequest.ts';

export class MediaclipThumbnailRequest<
  T,
  D = Record<string, never>,
> extends AbstractApiRequest<T, D> {
  private projectId: string = '';

  protected getEndPoint(): string {
    return `${this.baseUrl}/canvascompany/mediaclip/thumbnail?projectId=${this.projectId}`;
  }

  public setProjectId(projectId: string): this {
    this.projectId = projectId;
    return this;
  }
}
